import { Form } from "@/components/ui/form"
import { useGestaoEquipeForm } from "../../hooks/use-gestao-equipe-form"
import { FormCpfCnpjField, FormTextField } from "@/components/form"
import { Button } from "@/components/ui/button"
import { Check, Loader } from "lucide-react"

export function GestaoEquipeForm({ projetoId, onSucess, onCancel }:
  {
    projetoId: number,
    onSucess?: () => void
    onCancel?: () => void
  }) {
  const { form, isPending, onSubmit } = useGestaoEquipeForm(projetoId, onSucess)

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-6"
      >
        <div className="grid grid-cols-2 gap-4">
          <FormTextField name="name" label="Nome completo" placeholder="Digite o nome completo" required />
          <FormTextField name="pj_name" label="Razão Social" placeholder="Digite a razão social" required />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <FormCpfCnpjField name="document" label="CPF" required />
          <FormCpfCnpjField name="pj_document" label="CNPJ" required />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <FormTextField name="email" label="E-mail" placeholder="Digite o e-mail" required />
          <FormTextField name="role" label="Cargo" placeholder="Digite o cargo" />
        </div>

        <div className="flex items-center gap-3 justify-end pt-2">
          <Button
            type="button"
            variant="outline"
            className="h-10 px-6 border-gray-600 text-gray-300 hover:bg-gray-700/50 rounded-lg font-medium text-sm"
            onClick={onCancel}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            disabled={isPending}
            className="h-10 px-6 bg-emerald-600 hover:bg-emerald-500 text-white rounded-lg gap-2 font-semibold text-sm transition-colors"
          >
            {isPending ? (
              <>
                <Loader className="w-4 h-4 animate-spin" />
                Cadastrando...
              </>
            ) : (
              <>
                <Check className="w-4 h-4" />
                Cadastrar Membro
              </>
            )}
          </Button>
        </div>
      </form>
    </Form>
  )
}